export default "__VITE_ASSET__BvWMajmy__"